import { render, staticRenderFns } from "./AddOrUpdateRetainSpecimen.vue?vue&type=template&id=1719c127&scoped=true&"
import script from "./AddOrUpdateRetainSpecimen.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdateRetainSpecimen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1719c127",
  null
  
)

export default component.exports